<script setup lang="ts">
document.title = 'TSG Technology Day 2024.03 &bullet; tsgroup.space'
</script>

<template>
  <div class="font-tech-day md:text-lg">
    <section class="bg-black text-white">
      <p class="mt-10 uppercase text-xs md:text-base text-gray-600">the <b>Tourism Software Group</b> presents</p>
      <h1 class="font-tech-day font-semibold text-4xl md:text-6xl">
        Technology Day <span class="font-extralight text-gray-600">2024.03</span>
      </h1>
      <hr class="w-56 border-b-2 md:border-b-8 border-gray-800 mt-2">
    </section>

    <section class="bg-gray-200 dark:bg-primary-800 dark:text-white text">
      <div class="text-sm md:text-lg">
        <p>
          Hi there,
        </p>
        <p>
          you are <b>working for a company and/or business unit that is part of the Tourism Software Group (TSG)</b>.
          As this group we are looking to <b>foster collaboration within the development and engineering departments</b>
          of the various business units.
        </p>
        <p>
          That's why we are <b>organizing a virtual conference</b> where all interested <b>technologists</b>
          from within the group can come together and <b>enjoy a day of learning and socialising</b>.
        </p>
        <p class="text-gray-600 dark:text-primary-300">
          The organizers,<br>
          Phil Gerber (Payyo), Barnaby Salter (DigiTickets) &amp; Dani Bloom (TrekkSoft)
        </p>
      </div>
    </section>

    <section class="bg-gray-800 text-white text">
      <div class="grid md:grid-cols-3 gap-10">
        <div class="border border-gray-500 p-10">
          <h2># who</h2>
          <ul class="list-disc ml-5">
            <li>All technologist of TSG business units</li>
            <li>No registration needed</li>
          </ul>
        </div>
        <div class="border border-gray-500 p-10">
          <h2>// when</h2>
          <ul class="list-disc ml-5">
            <li>14 March 2024 <em>aka <a href="https://en.wikipedia.org/wiki/Pi_Day" target="_blank" class="link">π day</a></em></li>
            <li>Start at 9:30 GMT</li>
            <li>Lunch break planned</li>
          </ul>
        </div>
        <div class="border border-gray-500 p-10">
          <h2>/* where */</h2>
          <ul class="list-disc ml-5">
            <li>Online/virtual</li>
            <li>Your employeer may organize something at your office</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="bg-gray-200 text">
      <div class="grid md:grid-cols-2 gap-10">
        <div class="p-10 bg-gray-600 text-white">
          <h2>host_a_session()</h2>
          <p>
            We are looking for people <b>interested in hosting technology related sessions</b>
            during this event. The topics can range from practical and work related (i.e. <b>"how we
            test our React application"</b>) things, to more general knowledge topics (i.e. <b>"the current state of AI"</b>).
            We're also open to live demos of products or systems (i.e. <b>"what we learned building our new client dashboard"</b>).
          </p>
          <p>
            Sessions should either be <b>15, 30 or 60 minutes</b> (incl. Q&amp;A) in length.
          </p>
          <a href="https://forms.gle/Toh6s4hEYF1cvKzNA" target="_blank" class="button">I'm in!</a>
        </div>
        <div class="p-10 bg-gray-900 text-white">
          <h2>shareYourInterests()</h2>
          <p>
            Even if you're not interested in presenting yourself, you can still <b>contribute by sharing your topics of interest</b>.
          </p>
          <p>
            For topics with high demand we will try to find internal or even external speakers.
          </p>
          <a href="https://forms.gle/xZgzPHTqNuLvDVy8A" target="_blank" class="button">I have ideas!</a>
        </div>
      </div>
    </section>

    <section class="bg-gray-800 text-white text">
      <h2>?</h2>
      <p>
        If you have any questions, please reach out to your development lead. We've made every lead aware of this event
        and they will be able to assist you with your questions and the organisation of the event within your business
        unit.
      </p>
      <p>
        If you still would like to reach out to us directly, please contact Phil at <a class="link" href="mailto:philippe@payyo.ch">philippe@payyo.ch</a>.
      </p>
    </section>
  </div>
</template>

<style scoped lang="scss">
section {
  @apply px-5 py-10 md:px-40 shadow-lg;
}

.text {
  @apply text-base md:text-lg;

  h2 {
    @apply font-tech-day font-semibold text-xl md:text-3xl md:mt-10 mb-4;

    &.no-margin {
      @apply mt-0;
    }
  }

  p {
    @apply mb-3 leading-relaxed;
  }

  b {
    @apply font-semibold;
  }

  a.link {
    @apply underline text-primary-500;
  }

  a.button {
    @apply p-4 px-8 bg-primary-700 shadow-lg mt-4 block text-center w-full font-semibold hover:bg-primary-800;
  }
}
</style>
